import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import TicketItem from './TicketItem';
import styles from './TicketsList.module.css';
import axios from 'axios';

const TicketsList = ({
  userId,
  restartAutoScroll,
  propShows,
  isAuthenticated,
  highlightedShowId,
  sendEvent,
  searchQuery = ''
}) => {
  const [shows, setShows] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const firstLoad = useRef(true);

  useEffect(() => {
    const fetchShows = async () => {
      try {
        if (propShows) {
          setShows(propShows);
        } else {
          const token = localStorage.getItem('authToken');
          const response = await axios.get('/api/purchased/list', {
            headers: { Authorization: `Bearer ${token}` },
          });
          setShows(response.data);
        }
        setIsLoading(false);
        if (firstLoad.current && restartAutoScroll) {
          restartAutoScroll();
          firstLoad.current = false;
        }
      } catch {
        setIsLoading(false);
      }
    };
    fetchShows();
  }, [propShows, restartAutoScroll]);

  useLayoutEffect(() => {
    if (highlightedShowId && shows.length > 0) {
      const el = document.getElementById(`show-${highlightedShowId}`);
      if (el) el.scrollIntoView({ behavior: 'auto', block: 'center' });
    }
  }, [highlightedShowId, shows]);

  const handleTagClick = (tag) => {
    setSelectedTags((prevTags) => {
      if (prevTags.includes(tag)) return prevTags.filter((t) => t !== tag);
      return [...prevTags, tag];
    });
  };

  // фільтрація по тегам: жанр / місто / артист-стікер / спецгості / саппорт
  const filteredByTags =
    selectedTags.length > 0
      ? shows.filter((s) =>
          selectedTags.every(
            (tag) =>
              s.genre === tag ||
              s.city === tag ||
              s.artistSticker === tag ||
              (s.specialGuests || []).includes(tag) ||
              (s.supportActs || []).includes(tag)
          )
        )
      : shows;

  // пошук
  const searchShows =
    searchQuery.trim() === ''
      ? filteredByTags
      : filteredByTags.filter((s) =>
          [
            s.title,
            s.artist,
            s.genre,
            s.city,
            s.venue,
            s.date,
            s.timeStart,
            s.artistSticker,
            ...(s.specialGuests || []),
            ...(s.supportActs || []),
          ]
            .join(' ')
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );

  return (
    <div className={`${styles.ticketsList} ${!isLoading ? styles.visible : ''}`}>
      {isLoading ? (
        <div className={styles.listSpinnerContainer}>
          <div className={styles.listSpinner}></div>
        </div>
      ) : (
        searchShows.map((show) => {
          const rowKey = `${show.id}-${show.orderId}`;
          return (
            <TicketItem
              key={rowKey}
              id={show.id}
              orderId={show.orderId}
              highlighted={show.id === highlightedShowId}

              /* концертні поля */
              coverImage={show.coverImage}
              title={show.title}
              genre={show.genre}
              artist={show.artist}
              specialGuests={show.specialGuests}
              supportActs={show.supportActs}
              city={show.city}
              venue={show.venue}
              date={show.date}
              timeStart={show.timeStart}
              artistSticker={show.artistSticker}

              /* мапінг цін (як у ShowList; якщо є) */
              priceTier1={show.priceTier1}
              priceTier2={show.priceTier2}

              /* інтеракції */
              onTagClick={handleTagClick}
              selectedTags={selectedTags}
              isAuthenticated={isAuthenticated}
              sendEvent={sendEvent}

              /* квиткові поля */
              ticketGenerated={show.ticketGenerated}
              ticketUrl={show.ticketUrl}
              downloadUrl={show.downloadUrl}
              purchasedPre={show.purchasedPre}
              purchasedFull={show.purchasedFull}
            />
          );
        })
      )}
    </div>
  );
};

export default TicketsList;

